
import React from 'react'
import PropTypes from 'prop-types'
import checkIcon from 'images/check-new.svg'
import Modal from 'component/utils/Modal'

const MissionBlockEditModalNew = ({
  text,
  onConfirm,
  title,
  okButton
}) => (
  <Modal  size='sm' className='mission-block-container-modal'>
    <div className='mission-block-new-modal'>
        <img src={checkIcon} />
        <p className='mission-modal-title'>{title}</p>
        <p className='mission-modal-text'>{text}</p>
        <button onClick={onConfirm}>{okButton}</button>
    </div>

  </Modal>

  )

MissionBlockEditModalNew.propTypes = {
  text: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  okButton: PropTypes.string.isRequired
}
export default MissionBlockEditModalNew
